/* =====================================================================
   ZAPIET QTY LIMITER – OPTIMIZED BUILD (Enhanced Performance)
===================================================================== */

(function(){
console.log("%c[QTY LIMITER ENABLED]","background:#111;color:#0f0;padding:4px");

/* ==================== CONFIG ACCESS ==================== */

const CFG = () => window.QTY_LIMITER_CONFIG || {};

// Cache restaurant ID to avoid repeated function calls
let cachedRestaurant = null;
let restaurantCacheTime = 0;
const RESTAURANT_CACHE_DURATION = 5000; // 5 seconds

function getRestaurant(){
    const now = Date.now();
    if (cachedRestaurant && (now - restaurantCacheTime) < RESTAURANT_CACHE_DURATION) {
        return cachedRestaurant;
    }
    
    try { 
        cachedRestaurant = String(window.ZapietEats?.getSelectedRestaurant?.()?.id || "");
        restaurantCacheTime = now;
        return cachedRestaurant;
    } catch(e){ 
        cachedRestaurant = "";
        return ""; 
    }
}

// Clear restaurant cache on Zapiet changes
function clearRestaurantCache() {
    cachedRestaurant = null;
    restaurantCacheTime = 0;
}

// Cache min qty lookups (they don't change during session)
const minQtyCache = new Map();

function getMinQty(variantId){
    if(!variantId) return null;
    variantId = String(variantId);
    
    // Check cache first
    if (minQtyCache.has(variantId)) {
        return minQtyCache.get(variantId);
    }

    const cfg = CFG();
    const restCfg = cfg.restaurants?.[getRestaurant()] || {};
    const fallback = cfg.fallback || {};

    const minQty = restCfg[variantId] ?? fallback[variantId] ?? null;
    
    // Cache the result
    minQtyCache.set(variantId, minQty);
    
    return minQty;
}

// Clear min qty cache on config changes
function clearMinQtyCache() {
    minQtyCache.clear();
}

/* ==================== UI BADGES (Optimized) ==================== */

// Cache wrapper elements
const wrapperCache = new WeakMap();

function wrap(input){
    if(!input) return null;
    
    // Check cache first
    if (wrapperCache.has(input)) {
        return wrapperCache.get(input);
    }
    
    let w=input.closest(".ql-wrap");
    if(!w){
        w=document.createElement("span");
        w.className="ql-wrap";
        w.style.cssText="display:inline-flex;align-items:center;gap:6px;";
        input.parentNode.insertBefore(w,input);
        w.appendChild(input);
    }
    
    // Cache for future use
    wrapperCache.set(input, w);
    return w;
}

// Cache badge elements
const badgeCache = new WeakMap();

function badge(input,text){
    const w=wrap(input);
    if (!w) return;
    
    let b = badgeCache.get(input);
    if(!b){
        b=w.querySelector(".ql-badge");
        if(!b){
            b=document.createElement("span");
            b.className="ql-badge";
            b.style.cssText="font-size:11px;padding:3px 6px;border-radius:10px;background:#FFE59D;border:1px solid #C8A200;font-weight:600;color:#000;display:inline-block;";
            w.appendChild(b);
        }
        badgeCache.set(input, b);
    }
    
    // Only update if text changed
    if (b.textContent !== text) {
        b.textContent=text;
    }
    b.style.display="inline-block";
}

function hideBadge(input){
    const b = badgeCache.get(input) || input?.closest(".ql-wrap")?.querySelector(".ql-badge");
    if(b && b.style.display !== "none") {
        b.style.display="none";
    }
}

/* ==================== BUTTON CONTROL (Optimized) ==================== */

// Cache button states to avoid redundant updates
const buttonStateCache = new WeakMap();

function setATC(btn,txt,disabled){
    if(!btn) return;
    
    const currentState = buttonStateCache.get(btn);
    const newState = `${txt}|${disabled}`;
    
    // Skip update if state hasn't changed
    if (currentState === newState) return;
    
    buttonStateCache.set(btn, newState);
    
    btn.disabled = disabled;
    btn.style.opacity = disabled?"0.5":"1";
    btn.style.pointerEvents = disabled?"none":"auto";
    if (btn.innerText !== txt) {
        btn.innerText = txt;
    }
}

// Cache checkout buttons
let checkoutButtons = null;
let checkoutButtonsTime = 0;
const CHECKOUT_CACHE_DURATION = 10000; // 10 seconds

function getCheckoutButtons() {
    const now = Date.now();
    if (checkoutButtons && (now - checkoutButtonsTime) < CHECKOUT_CACHE_DURATION) {
        return checkoutButtons;
    }
    
    checkoutButtons = document.querySelectorAll(`
        button[name="checkout"], #checkout,
        form[action*="/checkout"] button[type="submit"],
        .t4s-cart-checkout, .t4s-checkout,
        .cart__checkout, .cart__submit,
        button.checkout, button[class*="checkout"],
        a[href*="/checkout"]
    `);
    checkoutButtonsTime = now;
    
    return checkoutButtons;
}

let lastCheckoutState = null;

function lockCheckout(state){
    // Skip if state hasn't changed
    if (lastCheckoutState === state) return;
    lastCheckoutState = state;
    
    const buttons = getCheckoutButtons();
    
    // Batch DOM updates
    requestAnimationFrame(() => {
        buttons.forEach(btn=>{
            btn.disabled = state;
            btn.style.opacity = state?"0.4":"1";
            btn.style.pointerEvents = state?"none":"auto";
        });
    });
}

/* ==================== PDP LIMITER (Optimized) ==================== */

const processedForms = new WeakSet();

function initPDP(){
    const forms = document.querySelectorAll('form[action*="/cart/add"],form[action="/cart/add"]');
    
    forms.forEach(form=>{
        if(processedForms.has(form)) return;
        processedForms.add(form);

        const id=form.querySelector('[name="id"]');
        const qty=form.querySelector('input[name="quantity"],input[name="qty"],input[type="number"],.t4s-qty-input');
        const atc=form.querySelector('button[type="submit"],.t4s-add-to-cart,.t4s-product-add-btn');

        if(!id||!qty||!atc) return;
        if(!atc.dataset.orig) atc.dataset.orig=atc.innerText.trim();

        // Cache last state to avoid redundant updates
        let lastState = null;

        function enforce(){
            const min=getMinQty(id.value);
            const val=+qty.value||0;
            const newState = `${min}|${val}`;
            
            // Skip if nothing changed
            if (lastState === newState) return;
            lastState = newState;

            if(!min){ 
                hideBadge(qty); 
                setATC(atc,atc.dataset.orig,false); 
                return; 
            }

            if(val < min){
                badge(qty,`MINIMUM OF ${min}`);
                setATC(atc,`MINIMUM OF ${min}`,true);
            } else {
                hideBadge(qty);
                setATC(atc,atc.dataset.orig,false);
            }
        }

        enforce();
        
        // Use passive listeners for better scroll performance
        qty.addEventListener("input", enforce, {passive: true});
        qty.addEventListener("change", enforce, {passive: true});
    });
}

/* ==================== CART LIMITER (Optimized) ==================== */

function initCart(){

    // Cache input selector results
    const INPUTS = () => {
        return Array.from(document.querySelectorAll('input[name^="updates"], .t4s-quantity-input,input.qty'));
    };
    
    const CART = document.querySelector('#CartContainer,.cart__items,.t4s-cart,form[action="/cart"],#MainContent') || document.body;

    // Track input states to avoid redundant processing
    const inputStates = new Map();

    function evaluate(){
        const items = INPUTS();
        
        if(!items.length){ 
            lockCheckout(false); 
            return; 
        }

        let block=false;
        let stateChanged = false;

        items.forEach(inp=>{
            const id=(inp.dataset.id||inp.name||"").match(/\d+/)?.[0];
            const min=getMinQty(id);
            const val=+inp.value||0;
            
            const newState = `${id}|${min}|${val}`;
            const oldState = inputStates.get(inp);
            
            // Only update if state changed
            if (oldState !== newState) {
                stateChanged = true;
                inputStates.set(inp, newState);
                
                if(min && val < min){ 
                    badge(inp,`MIN ${min}`); 
                    block=true; 
                } else {
                    hideBadge(inp);
                }
            } else if (min && val < min) {
                block = true;
            }
        });

        // Only update checkout state if something changed
        if (stateChanged || lastCheckoutState === null) {
            lockCheckout(block);
        }
    }

    // Debounce with requestAnimationFrame for smoother updates
    let rafId = null;
    let timeoutId = null;

    const run = () => {
        if (rafId) cancelAnimationFrame(rafId);
        if (timeoutId) clearTimeout(timeoutId);
        
        timeoutId = setTimeout(() => {
            rafId = requestAnimationFrame(evaluate);
        }, 90);
    };

    evaluate();

    // Live triggers with passive listeners
    document.addEventListener("input", run, {passive: true});
    document.addEventListener("change", run, {passive: true});
    document.addEventListener("t4s:ajaxComplete", run);
    document.addEventListener("shopify:section:load", run);
    document.addEventListener("cart:refresh", run);

    // Smarter mutation observer - only trigger on relevant changes
    let mutationTimeout = null;
    const observer = new MutationObserver((mutations) => {
        // Check if mutations actually affect quantity inputs
        const hasRelevantChange = mutations.some(m => 
            Array.from(m.addedNodes).some(node => 
                node.nodeType === 1 && (
                    node.matches?.('input[name^="updates"], .t4s-quantity-input,input.qty') ||
                    node.querySelector?.('input[name^="updates"], .t4s-quantity-input,input.qty')
                )
            )
        );
        
        if (hasRelevantChange) {
            if (mutationTimeout) clearTimeout(mutationTimeout);
            mutationTimeout = setTimeout(run, 100);
        }
    });
    
    observer.observe(CART, {
        childList: true, 
        subtree: true,
        attributes: false, // Don't watch attribute changes
        characterData: false // Don't watch text changes
    });
}

/* ==================== INIT (Optimized) ==================== */

let initialized = false;

function start(){ 
    if (initialized) return; // Prevent double initialization
    
    try {
        initPDP(); 
        initCart();
        initialized = true;
    } catch(e) {
        console.error("[QTY LIMITER] Init error:", e);
    }
}

// Listen for Zapiet changes to clear caches
function handleZapietChange() {
    clearRestaurantCache();
    clearMinQtyCache();
    checkoutButtons = null; // Force refresh of checkout buttons
    lastCheckoutState = null; // Force re-evaluation
    
    // Re-evaluate after cache clear
    setTimeout(() => {
        if (initialized) {
            try {
                initPDP();
                
                // Manually trigger cart evaluation
                const event = new Event('change', { bubbles: true });
                document.dispatchEvent(event);
            } catch(e) {
                console.error("[QTY LIMITER] Re-evaluation error:", e);
            }
        }
    }, 200);
}

// Use requestIdleCallback for better initial performance
const scheduleInit = () => {
    if ('requestIdleCallback' in window) {
        requestIdleCallback(start, { timeout: 500 });
    } else {
        setTimeout(start, 180);
    }
};

if (document.readyState === 'loading') {
    document.addEventListener("DOMContentLoaded", scheduleInit);
} else {
    scheduleInit();
}

document.addEventListener("zapieteats:ready", handleZapietChange);
document.addEventListener("zapieteats:change", handleZapietChange);

})();